import { useState } from 'react';
import { toast } from 'react-toastify';

import { UsersApi } from '@/api/clients/users/users.api';

const buildFiltersFromSearchParams = (searchParams, keys) => {
  const filters = {};

  keys.forEach(({ param, key, parse }) => {
    const value = searchParams.get(param);
    if (value) {
      filters[key] = parse ? parse(value) : value;
    }
  });

  return filters;
};

export const useFacilityUserBulkActions = ({
  searchParams,
  t,
  exportUsers,
}) => {
  const [isCopyingEmails, setIsCopyingEmails] = useState(false);

  const handleCopyAllEmails = async () => {
    setIsCopyingEmails(true);
    try {
      const filters = buildFiltersFromSearchParams(searchParams, [
        { param: 'organization_id', key: 'organization_id', parse: parseInt },
        { param: 'facility_id', key: 'facility_id', parse: parseInt },
      ]);

      const response = await UsersApi.getFacilityUserEmails(filters);
      const emails = response.data;

      if (!emails || emails.length === 0) {
        toast.info(t('facilityUserManagement.noEmailsToCopy'));
        return;
      }

      await navigator.clipboard.writeText(emails.join(', '));

      toast.success(
        t('facilityUserManagement.copyAllEmailsSuccess', {
          count: emails.length,
        }),
      );
    } catch (error) {
      console.error('Failed to copy emails:', error);
      toast.error(t('facilityUserManagement.copyAllEmailsError'));
    } finally {
      setIsCopyingEmails(false);
    }
  };

  const handleExportUsers = () => {
    const filters = buildFiltersFromSearchParams(searchParams, [
      { param: 'organization_id', key: 'organization_id', parse: parseInt },
      { param: 'facility_id', key: 'facility_id', parse: parseInt },
      {
        param: 'facility_group_id',
        key: 'facility_group_id',
        parse: parseInt,
      },
      { param: 'status', key: 'status' },
      { param: 'search', key: 'search' },
    ]);

    exportUsers(filters);
  };

  return {
    isCopyingEmails,
    handleCopyAllEmails,
    handleExportUsers,
  };
};
